module.exports = __webpack_public_path__ + "assets/img/0662.d2a4441b.png";